import { ISection } from 'src/interface';
import { SECTION_ID } from 'src/constants';
import { ArrayUtils } from 'src/utils';
import {
    ContentMoreSection,
    ContentTopSection,
    ContentTopicSection,
    ContentLocationSection,
    ContentTagSection,
    PublisherSection,
    ContentWithFetchSection,
    ContentSection,
} from 'src/modules/content/components/sections';
import { AdBanner, AdNative } from '../ad';
import Banner from '../Banner';
import { SOCCER_SECTION_ID } from 'src/modules/soccer/constants';
import { ScoreSection } from 'src/modules/soccer/view/home';

const SECTION_MAP = {
    [SECTION_ID.CONTENT]: ContentSection,
    [SECTION_ID.CONTENT_LIST_TOP]: ContentTopSection,
    [SECTION_ID.CONTENT_LIST_MORE]: ContentMoreSection,
    [SECTION_ID.CONTENT_FETCH_LIST]: ContentWithFetchSection,
    [SECTION_ID.CONTENT_BY_TOPIC]: ContentTopicSection,
    [SECTION_ID.CONTENT_BY_REGION]: ContentLocationSection,
    [SECTION_ID.CONTENT_TAG]: ContentTagSection,
    [SECTION_ID.PUBLISHER]: PublisherSection,
    [SECTION_ID.ADBANNER]: AdBanner,
    [SECTION_ID.ADNATIVE]: AdNative,
    [SECTION_ID.BANNER]: Banner,
    [SOCCER_SECTION_ID.SCORE]: ScoreSection,
};

export function renderSections(
    items: ISection<any>[] = [],
    sectionCustom: object = {},
    isBot = false,
    isMobile = true
) {
    const sectionMap = Object.assign({}, SECTION_MAP, sectionCustom);
    return items.map((item, index) => {
        if (item.isShuffle) {
            item.items = shuffleItems(item.items);
            item.isShuffle = false;
        }

        return renderSection(sectionMap, item, index, isMobile, isBot);
    });
}

function renderSection(
    sectionMap: any = {},
    item: ISection<any>,
    index: number,
    isMobile: boolean = true,
    isBot: boolean = false
) {
    // if (!item.sectionId) {
    //     return null;
    // }

    const Component = sectionMap['' + item.sectionId];

    if (Component) {
        const props: any = {
            ...item,
            isMobile,
            lazyloadImage: !isBot,
            ContentItemProps: {
                lazyloadImage: !isBot,
            }
        };

        return <Component key={`section.item.${index}`} {...props} />;
    }

    return null;
}

function shuffleItems(items: any[] = []) {
    const adNativeMap: any = {};
    const length = items.length;

    let _items = items.filter((item, index) => {
        if (!item.contentId) {
            adNativeMap[index] = item;
            return false;
        }
        return true;
    });

    _items = ArrayUtils.shuffle(_items);

    for (let i = 0; i < length; i++) {
        if (adNativeMap[i]) {
            ArrayUtils.insert(_items, adNativeMap[i], i);
        }
    }
    return _items;
}
